import type { JSX } from 'react';

import { withPrefetchedData } from 'src/shared/prefetch';

import { CountryBannerContainer } from 'src/app/shared/components/banners/country';
import { prefetchCountryBanner, useCountryBanner } from 'src/app/shared/hooks/banners/country';

import { HomepageNotice, prefetchHomepageNotice, useHomepageNotice } from './HomepageNotice';

export const Banner = withPrefetchedData(
	(): JSX.Element | null => {
		const countryBanner = useCountryBanner('home');
		const homepageNotice = useHomepageNotice();

		if (homepageNotice) {
			return <HomepageNotice homepageNotice={homepageNotice} />;
		}

		if (countryBanner) {
			return <CountryBannerContainer context="home" countryBanner={countryBanner} />;
		}

		return null;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [CountryBannerContainer, HomepageNotice],
		prefetchData: async (context) => {
			await Promise.all([prefetchCountryBanner(context), prefetchHomepageNotice(context)]);
		},
	},
);
